module.exports = __webpack_public_path__ + "a2a78e45f2c663f782b0316ade5a0fd9.png";